import { translations } from '@adornis/adornis-components/translations.js';
import { dataViewTranslations } from '@adornis/data-view/default-translations.js';
import { fieldManagementTranslations } from '@adornis/field-management/default-translations.js';
import { filterTranslations } from '@adornis/filter/default-translations.js';
import { Language } from '@adornis/translation-core/languages.js';
import { defaultWikiTranslation } from '@adornis/wiki/translation.js';

export const languages = { german: Language.GERMAN, english: Language.ENGLISH };

export const productFieldTranslation = {
  _class: ['Produktart'],
  _root: ['Produkt'],
  betreuungsverhaeltnis: ['Betreueungsverhältnis'],
  aufenthalt: ['Aufenthalt'],
  betreuungsintensitaet: ['Betreueungsintensität'],
  lernkaskadeAufenthalt: ['LKK Aufenthalt'],
  lernfoerderungAufenthalt: ['LeFö Aufenthalt'],
  durchfuehrungsTage: {
    _root: ['Durchführungstage'],
    wochentag: ['Tag'],

    locations: ['Lernförderungsräume'],
  },
  ikProWoche: ['Intensivkurse pro Woche'],
  ikDauer: ['Intensivkursdauer in Minuten'],
  leFoeProWoche: ['Lerförderungen pro Woche'],
  leFoeDauer: ['Lerförderungsdauer in Minuten'],
  uebungsLeiterProIK: ['Übungsleitungen pro Intensivkurs'],
  OSProIK: ['OS-Schüler:innen pro Intensivkurs'],
  OSLernFoerderung: ['OS-Schüler:innen pro Lerförderung'],
  USLernFoerderung: ['US-Schüler:innen pro Lerförderung'],
  location: ['Standort CHANCENschule'],
  uebungsLeiterProLernFoerderung: ['LKK Gesamt-Leko-Bedarf (Startwert)'],
};

export const butFieldTranslation = {
  year: ['BuT Jahr'],
  BuTBerechtigung: ['BuT-Berechtigung'],
  assignedPersonForParentalContact: ['Zugewiesene Person für Elternkontakt'],
  BuTUnterlagenEltern: ['BuT-Unterlagen Eltern'],
  grundantragErhalten: ['Grundantrag erhalten'],
  leistungsbescheidErhalten: ['Leistungsbescheid erhalten'],
  zeugnisErhalten: ['Zeugnis erhalten'],
  verschwiegenheitsbogenErhalten: ['Verschwiegenheitserklärung erhalten'],
  BuTUnterlagenVollstaendig: ['BuT-Unterlagen vollständig'],
  elternkontakt: ['Elternkontakt'],
  elternkontaktFehlgeschlagen: ['Elternkontakt fehlgeschlagen'],
  anlassKommentarElternkontakt: ['Anlasskommentar Elternkontakt'],
  zusatzbogenSchuleVersendet: ['Zusatzbogen Schule versendet'],
  zusatzbogenSchuleErhalten: ['Zusatzbogen Schule erhalten'],
  vereinbarungsnotitzSchule: ['Vereinbarung Notiz Schule'],
  leistungstraeger: ['Leistungsträger'],
  antragTeilweiseVersendet: ['Antrag teilweise versendet'],
  antragVollstaendigVersendet: ['Antrag vollständig versendet'],
  vereinbarungsnotitzAmt: ['Vereinbarung Notiz Amt'],
  antragsteller: ['Antragsteller'],
  aktenzeichen: ['Aktenzeichen'],
  BuTBewilligungAb: ['BuT-Bewilligung ab'],
  BuTBewilligungBis: ['BuT-Bewilligung bis'],
  BuTBerechtigungDurch: ['BuT-Berechtigung durch'],
  kommentarBuT: ['Kommentar BuT'],
  anlassKommentarBuTSchuko: ['Kommentar/Info'],
  kindNimmtNichtTeilStand: ['Kind nimmt nicht teil Stand'],
  faecher: {
    _root: ['Fächer'],
    subject: ['Fach'],
    approved: ['Fach bestätigt'],
    berechneteStunden: ['berechnete Einheiten'],
    bewilligteStunden: ['bewilligte Einheiten'],
  },
  sonstigeFaecherTmp: ['Sonstige Fächer'],
  BuTMassnahmenEinstellenBis: ['BuT-Maßnahmen einstellen bis'],
  leistungsbescheidBerlinPassGueltigBis: ['Leistungsbescheid gültig bis'],
  abgerechnetBis: ['abgerechnet bis'],
  kommentarAbrechnung: ['Kommentar Abrechnung'],
  berechneteStunden: ['berechnete Einheiten'],
  bewilligteStunden: ['bewilligte Einheiten'],
};

export const bankInformationTranslations = {
  kontoinhaber: ['Kontoinhaber'],
  iban: ['IBAN'],
  bic: ['BIC'],
  kreditinstitut: ['Kreditinstitut'],
  ibanFalsch: ['IBAN falsch'],
  vermerkeZahlungsverkehr: ['Vermerke Zahlungsverkehr'],
  debitorennummer: ['Debitorennummer'],
  mandatsdatum: ['Mandatsdatum'],
  mandatsreferenz: ['Mandatsreferenz'],
  zahlungsart: ['Zahlungsart'],
  zahlungAusgesetztAb: ['Zahlung ausgesetzt ab'],
  zahlungAusgesetztBis: ['Zahlung ausgesetzt bis'],
  mitgliedsbeitrag: ['Mitgliedsbeitrag in €'],
  membershipFeeLowerThan20: ['Wünscht niedrigeren Mitgliedsbeitrag'], //used to be 20 for all, now it's custom
  wishesProofOfPayment: ['Nachweis über Beitragszahlungen gewünscht'],
};

/** [Daniel-Todo] use nested fields here in the future */
export const translationData = {
  // General things

  ...defaultWikiTranslation,

  action_picker: {
    start: ['Zurück', 'Back'],
    navigate: ['Navigieren', 'Navigate'],
    back: ['Zurück', 'Back'],
    execute: ['Ausführen', 'Execute'],
    close: ['Schließen', 'Close'],
    nothing_found: ['Nichts gefunden', 'Nothing found'],
  },

  us: { title: ['Anmeldung zur Lernkaskade', 'Learning cascade registration form'] },
  os: { title: ['Anmeldung zur CHANCENreise', 'Learning cascade registration form'] },

  // Personal Information
  job: ['Beruf', 'Occupation'],
  mobile: ['Handynummer', 'Phonenumber'],
  mobileLegalGuardian: ['Handynummer Erziehungsberechtigte:r', 'Phonenumber of the legal guardian'],
  phone: ['Festnetz', 'Landline'],
  email: ['E-Mail', 'E-Mail'],
  emailLegalGuardian: ['E-Mail Erziehungsberechtigte:r', 'E-Mail of the legal guardian'],

  adress: {
    street: ['Straße', 'Street'],
    number: ['Hausnummer', 'Housenumber'],
    zip: ['PLZ', 'ZIP Code'],
    location: ['Ort', 'Location'],
    different: ['Adresse abweichend', 'Different address'],
  },

  step0: {},
  step1: {
    header: ['Schulische Daten', 'School information'],
    teacher: ['Klassenlehrer:in', 'Teacher'],
    grade: ['Jahrgangsstufe', 'Schoolgrade'],
    zug: ['Klassenzug', 'Schoolclass'],
    school: ['Schule', 'School'],
    bundesland: ['Bundesland', 'State'],

    noSchools: ['Keine Schulen für diese Stadt vorhanden!', '#english'],

    us: {
      sectionHeaderSchool: [
        'Hiermit melde ich mein Kind für die Lernkaskade von Chancenwerk e.V. an.',
        'I hereby register my child for the learning cascade of Chancenwerk e.V.',
      ],
      schoolQuestion: ['Auf welche Schule geht Ihr Kind?', 'Which school does you child attend to?'],
      cityReminder: ['Bitte geben Sie die Stadt ein, in der Ihr Kind zur Schule geht.', '#english'],
      schoolReminder: ['Bitte wählen Sie die Schule Ihres Kindes aus.', '#english'],
    },
    os: {
      sectionHeaderSchool: [
        'Hiermit melde ich mich zur CHANCENreise von Chancenwerk e.V. an.',
        'I hereby register myself at the learning cascade of Chancenwerk e.V.',
      ],
      schoolQuestion: ['Auf welche Schule gehst du?', 'Which school do you go to?'],
      cityReminder: ['Bitte gib die Stadt ein, in der du zur Schule gehst.', '#english'],
      schoolReminder: ['Bitte wähle eine Schule aus.', '#english'],
    },
    graduation: {
      schoolQuestion: ['Auf welche Schule gehst du?', 'Which school do you go to?'],
      cityReminder: ['Bitte gib die Stadt ein, in der du zur Schule gehst.', '#english'],
      schoolReminder: ['Bitte wähle eine Schule aus.', '#english'],
      bundeslandReminder: ['Bitte gib das Bundesland ein, in dem du zur Schule gehst.', '#english'],
    },
  },
  step2: {
    legalGuardianInformation: ['Erziehungsberechtigte', 'Details of the legal guardian'],

    parentAddress: ['Abweichende Adresse', '#english'],

    general: ['Allgemein', '#english'],

    us: {
      sectionHeaderChild: ['Schüler:in', '#english'],
      childAddress: ['Adresse des Kindes', 'Address of the child'],
    },
    os: { sectionHeaderChild: ['Schüler:in', '#english'], childAddress: ['Deine Adresse', 'Address of the child'] },
    graduation: { sectionHeaderChild: ['Schüler:in', '#english'], childAddress: ['Deine Adresse', 'Your address'] },
  },
  step3: {
    us: { lkkDays: ['An welchen Tagen wird Ihr Kind an der Lernkaskade teilnehmen?', '#english'] },
    os: { lkkDays: ['Möchtest du ein oder zwei Mal wöchentlich in der Lernförderung helfen?', '#english'] },
  },
  step4: {},
  step5: {
    partOne: ['Teil 1: Persönliche Angaben zum Kind', 'Part 1: Personal information about the child'],
    partTwo: [
      'Teil 2: Aufsichtpflicht, Entbingung von der Schweigepflicht, Widerruf & Kündigung',
      'Part 2: Duty of Supervision, Release from Confidentiality, Revocation & Termination',
    ],
    partTwoConsentError: ['Dem Teil 2 muss zugestimmt werden!', 'Part two needs to be accepted'],
    partThree: ['Teil 3: Einwilligungserklärung (Evaluation)', 'Part 3: Declaration of consent (evaluation)'],
    partThreeInformation: [
      'Wir wollen Ihr Kind gut unterstützen und es soll sich bei uns wohlfühlen. Deshalb überprüfen wir unsere Arbeit und unser Konzept regelmäßig. Dazu befragen wir die Schüler:innen und Sie. Die Befragung erfolgt ohne Nennung von Namen.',
      'We want to support your child well and he or she should feel comfortable with us. Therefore, we regularly review our work and our concept. To do this, we survey the students and you. The survey is carried out without naming names.',
    ],
    partFour: [
      'Teil 4: Einwilligungserklärung (Nutzung von Foto- und Videoaufnahmen)',
      'Part 4: Declaration of consent (use of photo and video recordings)',
    ],
  },

  errorIBANInvalid: ['Dies ist keine gültige IBAN.'],
  errorBeitragInvalid: ['Dies ist kein gültiger Mitgliedsbeitrag.'],

  errorUserVorname: ['Bitte geben Sie einen Vornamen an.'],
  errorUserNachname: ['Bitte geben Sie einen Nachnamen an.'],

  errorStudentType: ['Bitte geben Sie den Schülertyp an.'],
  errorStudentGeburtstag: ['Der Geburtstag darf nicht in der Zukunft liegen.'],
  errorStudentHandynummer: ['Bitte gebe deine Handynummer ein.'],
  errorStudentEmail: ['Bitte gebe deine E-Mail Adresse ein.'],
  errorStudentInvalidEmail: ['Dies ist keine gültige E-Mail Adresse.'],
  errorExternalEmail: ['Bitte geben Sie eine E-Mail Adresse an.'],
  errorJahrgangsstufe: ['Eine Jahrgangsstufe muss ausgewählt sein!'],
  errorEmail: ['Bitte gebe deine E-Mail an!'],
  errorHandynummer: ['Bitte gebe deine Handynummer an!'],
  errorErstwunsch: ['Bitte gebe einen Erstwunsch an!'],
  errorGeburtstagUs: ['Bitte geben Sie einen Geburtstag an!'],
  errorGeburtstagOs: ['Bitte gebe deinen Geburtstag an!'],
  errorStrasse: ['Die Adresse muss vollständig angegeben werden! Straße fehlt...'],
  errorHausnummer: ['Die Adresse muss vollständig angegeben werden! Hausnummer fehlt...'],
  errorStadt: ['Die Adresse muss vollständig angegeben werden! Stadt fehlt...'],
  errorVorname: ['Bitte geben Sie einen Vornamen an'],
  errorNachname: ['Bitte geben Sie einen Vornamen an'],
  errorHandyFestnetz: ['Die Handy- oder Festnetznummer eines Erziehungsberechtigten wird benötigt'],
  errorEmailGuardian: ['Die E-Mail-Adresse eines Erziehungsberechtigten wird benötigt'],
  errorEmailInvalid: ['keine gültige E-Mail.'],
  errorAddressIncorect: ['Adresse wurde als nicht korrekt gekennzeichnet!'],
  errorBuT: ['Kontoinhaber:in muss ausgefüllt werden, wenn keine BuT Berechtigung vorliegt'],
  errorBuTIBAN: ['Die IBAN muss ausgefüllt werden, wenn keine BuT Berechtigung vorliegt'],
  errorBuTBerechtigungDurch: ['"BuT-Berechtigt durch" muss ausgefüllt werden'],
  errorSubject: ['Bitte wähle mindestens ein Fach aus!'],
  errorDay: ['Bitte wähle mindestens einen Wochentag aus!'],

  tooltips: {
    school: ['Es werden nur unsere Kooperationsschulen angezeigt.', '#english'],
    zug: ['z.B. a, b oder c', '#english'],
    further_instructions_from_parent: [
      'Sie können mehrere Fächer auswählen. Erläuterungen können Sie bei Bedarf unter "Sonstige Hinweise" machen.',
      '',
    ],
    further_instructions_other_lectures: ['Gibt es noch andere Fächer, in denen Ihr Kind Unterstützung benötigt?', ''],
    further_instructions_weaknesses: [
      'Die Angabe ist freiwillig, kann uns aber bei der Betreuung helfen. Sie können mehrere Optionen auswählen.',
      '',
    ],
    further_instructions_days_available: [
      'Ihr Kind sollte möglichst an allen Betreuungstagen teilnehmen. Sollte dies nicht möglich sein, haben Sie hier die Möglichkeit, die Betreuungstage anzupassen. Regelmäßige Abweichungen teilen Sie uns bitte unter "Sonstige Hinweise zum Kind" mit (z.B. "Muss immer 10 Minuten früher gehen, um den Bus mitzubekommen.")',
      '',
    ],
    further_instructions_further_instruction: [
      'Was sollten wir über Ihr Kind wissen, damit wir es bestmöglich betreuen können?',
      '',
    ],
    billing_contribution: [
      'Sie möchten mehr als {fee} Euro zahlen? Dann ändern Sie den Betrag hier in dem Feld.',
      'Would you like to pay more than {fee} euros? Then adjust the amount in this field.',
    ],
    free_text_subject: [
      'Die Kurse finden werktags am Abend statt! Wenn wir die Kurse zusammengestellt haben, erhälst du eine E-Mail mit deiner Einteilung.',
    ],
    bundesland_missing: ['Für weitere Bundesländer wird kein CHANCENabschluss angeboten.'],
  },

  errors: { firstname: ['Vorname des Schuelers wurde nicht angegeben', 'First name of the student was not specified'] },

  info: {
    intro1: [
      'Hiermit melde ich mein Kind für die Lernkaskade von Chancenwerk e.V. an.',
      'I hereby register my child for the learning cascade of Chancenwerk e.V.',
    ],
  },
  title: ['Anmeldung zur Lernkaskade', 'Learning cascade registration form'],
  save: ['Speichern', 'Save'],
  partOne: ['Teil 1: Persönliche Angaben zum Kind', 'Part 1: Personal information about the child'],
  partTwo: [
    'Teil 2: Aufsichtpflicht, Entbingung von der Schweigepflicht, Widerruf & Kündigung',
    'Part 2: Duty of Supervision, Release from Confidentiality, Revocation & Termination',
  ],
  partTwoConsentError: ['Dem Teil 2 muss zugestimmt werden!', 'Part two needs to be accepted'],
  partThree: ['Teil 3: Einwilligungserklärung (Evaluation)', 'Part 3: Declaration of consent (evaluation)'],
  partThreeInformation: [
    'Wir wollen Ihr Kind gut unterstützen und es soll sich bei uns wohlfühlen. Deshalb überprüfen wir unsere Arbeit und unser Konzept regelmäßig. Dazu befragen wir die Schüler:innen und Sie. Die Befragung erfolgt ohne Nennung von Namen.',
    'We want to support your child well and he or she should feel comfortable with us. Therefore, we regularly review our work and our concept. To do this, we survey the students and you. The survey is carried out without naming names.',
  ],
  partFour: [
    'Teil 4: Einwilligungserklärung (Nutzung von Foto- und Videoaufnahmen)',
    'Part 4: Declaration of consent (use of photo and video recordings)',
  ],
  firstName: ['Vorname', 'Prename'],
  lastName: ['Nachname', 'Lastname'],
  birthday: ['Geburtstag', 'Birthday'],
  gender: ['Geschlecht', 'Gender'],
  nationality: ['Staatsangehörigkeit', 'Nationality'],
  school: ['Auf welche Schule geht Ihr Kind?', 'What school does your child go to?'],
  teacher: ['Klassenlehrer:in', 'Teacher'],
  grade: ['Jahrgangsstufe', 'Schoolgrade'],
  classLabel: ['Klassenzug', 'Schoolclass'],
  guardian: {
    firstName: ['Vorname', 'Prename'],
    lastName: ['Nachname', 'Lastname'],
    nationality: ['Staatsangehörigkeit', 'Nationality'],
    job: ['Beruf', 'Occupation'],
    mobile: ['Handynummer', 'Phonenumber'],
    phone: ['Festnetz', 'Landline'],
    email: ['E-Mail', 'E-Mail'],
    gender: ['Geschlecht', 'Gender'],
  },
  next: ['Weiter', 'Next'],
  back: ['Zurück', 'Back'],
  childAddress: ['Adresse des Kindes', 'Address of the child'],
  parentAddress1: ['Abweichende Adresse erziehungsberechtigte Person 1', 'Address of the person 1'],
  parentAddress2: ['Abweichende Adresse erziehungsberechtigte Person 2', 'Address of the person 2'],
  generalInformation: ['Schulische Angaben', 'School information'],
  prenameError: ['Vorname des Schuelers wurde nicht angegeben', 'First name of the student was not specified'],
  emptyError: ['Bitte dieses Feld ausfüllen', 'Please fill out this field'],
  registrationThanks: ['Vielen Dank für die Anmeldung', 'Thank you for registration'],
  mandatoryInformation: ['Felder mit * sind verpflichtend auszufüllen', 'Fields marked with * are mandatory'],
  genderMale: ['männlich', 'male'],
  genderFemale: ['weiblich', 'female'],
  genderDiverse: ['divers', 'diverse'],
  legalGuardianInformation: ['Angaben zu den Erziehungsberechtigten', 'Details of the legal guardian'],
  loadingStudentInformation: ['Schülerdaten werden geladen...', 'Loading student data...'],
  moreInformationForChild: ['Weitere Angaben zum Kind', 'Other information about the child'],
  yes: ['Ja', 'Yes'],
  no: ['Nein', 'No'],
  applicantName: ['Name Antragssteller:in', 'Applicant name'],
  fileNumber: ['Aktenzeichen/BG-Nummer', 'Reference/BG-Number'],
  consentDeclaration: ['Einwilligungserklärung', 'Declaration of consent'],
  privacyInformationText: [
    'Die Datenschutzinformationen sind auf unserer Webseite zu finden',
    'The privacy information can be found on our website',
  ],
  statementAgree: ['Ich stimme der Erklärung zu', 'I agree with the statement'],
  pleaseFillout: [
    'Bitte füllen Sie zudem die folgenden Felder aus. Diese Angaben benötigen wir, um Ihre BuT-Unterlagen zu erstellen.',
    'Please also fill in the following fields. We need this information in order to create the necessary BuT documents and provide them to you as soon as possible.',
  ],
  creditInstitution: ['Kreditinstitut', 'Credit institution'],
  accountHolder: ['Kontoinhaber:in', 'Account holder'],
  i_want: ['Monatlicher Mitgliedsbeitrag', 'I can help with'],
  giveEuro: ['Euro', 'Euro'],
  confirm: ['Absenden', 'Confirm'],
  complete_registration: ['Anmeldung abschließen', '#english'],
  childSupportNeeds: ['Fachlicher Förderbedarf des Kindes', 'Support needs of the child'],
  other_subjects: ['Sonstige Fächer', 'Other Subjects'],
  BuT_question: [
    'Anspruch auf Bildungs- und Teilhabepaket?',
    'Is there an entitlement for the education and participation package (BuT)?',
  ],
  BuT_berechtigung: ['BuT Berechtigung', 'BuT Authorization'],
  performance_weaknesses: ['Besonderheiten des Kindes', 'Partial performance weaknesses of the child'],
  other_child_information: ['Sonstige Hinweise', 'Other information'],
  money_question: [
    'Die auswählbaren Beträge richten sich nach dem für die Schule hinterlegten Standardmitgliedsbeitrag.',
    'The available amounts depend on the standard membership fee configured for the school.',
  ],
  less_than_20: ['Ich möchte weniger als {fee}€ beitragen.', 'I would like to contribute less than {fee} euros.'], //used to be 20€ for all
  provide_email: ['Bitte geben sie eine E-Mail an.', 'Please provide an E-Mail.'],
  provide_prename: ['Bitte geben sie den Vornamen an.', 'Please provide an prename.'],
  provide_lastname: ['Bitte geben sie den Nachnamen an.', 'Please provide an lastname.'],
  address_confirm: ['Stimmt die angegebene Adresse?', 'Is this the right address?'],
  self_service_question_part1_2: [
    'Ich möchte Teil 1 & 2 postalisch zugeschickt bekommen',
    'I want to receive part 1 & 2 by mail',
  ],
  days_available: ['Teilnahmetage', 'My child has time on'],
  FIRST_DAY: ['1. Tag', '1. Day'],
  SECOND_DAY: ['2. Tag', '2. Day'],
  Montag: ['Montag', 'Monday'],
  Dienstag: ['Dienstag', 'Tuesday'],
  Mittwoch: ['Mittwoch', 'Wednesday'],
  Donnerstag: ['Donnerstag', 'Thursday'],
  Freitag: ['Freitag', 'Friday'],
  Samstag: ['Samstag', 'Saturday'],
  Sonntag: ['Sonntag', 'Sunday'],

  tooltip_general_kpf: ['Es werden nur unsere Kooperationsschulen angezeigt.', ''],
  tooltip_general_class: ['z.B. a, b oder c', ''],
  tooltip_further_instructions_from_parent: [
    'Sie können mehrere Fächer auswählen. Erläuterungen können Sie bei Bedarf unter "Sonstige Hinweise zum Kind" ganz unten machen.',
    '',
  ],
  tooltip_further_instructions_other_lectures: [
    'Gibt es noch andere Fächer, in denen Ihr Kind Unterstützung benötigt?',
    '',
  ],
  tooltip_further_instructions_weaknesses: [
    'Die Angabe ist freiwillig, kann uns aber bei der Betreuung helfen. Sie können mehrere Optionen auswählen.',
    '',
  ],
  tooltip_further_instructions_days_available: [
    'Ihr Kind sollte möglichst an allen Betreuungstagen teilnehmen. Sollte dies nicht möglich sein, haben Sie hier die Möglichkeit, die Betreuungstage anzupassen. Regelmäßige Abweichungen teilen Sie uns bitte unter "Sonstige Hinweise zum Kind" mit (z.B. "Muss immer 10 Minuten früher gehen, um den Bus mitzubekommen.")',
    '',
  ],
  tooltip_further_instructions_further_instruction: [
    'Was sollten wir über Ihr Kind wissen, damit wir es bestmöglich betreuen können?',
    '',
  ],
  tooltip_billing_contribution: [
    'Der empfohlene reduzierte Mitgliedsbeitrag liegt bei {fee} Euro. Sie wollen freiwillig mehr zahlen? Bitte wählen Sie einen anderen Betrag aus! Sie möchten weniger zahlen? Bitte wählen Sie das Feld unten aus!',
    'The recommended reduced membership contribution is {fee} euros. If you want to contribute more voluntarily, please choose a different amount. If you want to contribute less, please use the field below.', // used to be 20€ for all
  ],
  Bildungkarte: ['Bildungkarte', 'Education card'],

  ...fieldManagementTranslations,
  ...filterTranslations,
  // Operator labels shown between an aspect's field name and its editor in the filter UI, keyed by
  // aspect `_class`. This object is the LEGACY catalog (read by `@adornis/translation-core` via
  // `translate('class', aspectClass)` — the old `x-filter-editor` and data-view exports).
  //
  // The app renders the NEWER functional `FilterEditor` (`@adornis/filter/client/filter-editor.js`),
  // which instead resolves `m['_filter_class_' + aspectClass]()` from the paraglide catalog. So for a
  // custom aspect to get a translated operator label there, add `_filter_class_<AspectClass>` to
  // `src/localisation/messages/de.json` as well — the two are not generated from each other.
  // (e.g. KPFMultipleAspect / ChancenRoleMultiAspect / ProductAspect: "ist eines von" lives in both.)
  class: {
    ...filterTranslations.class,
    FundingAspect: ['ist', 'is'],
    StudentTypeAspect: ['ist', 'is'],
    ProductAspect: ['ist eines von', 'is one of'],
    KPFAspect: ['ist', 'is'],
    GraduationSubjectAspect: ['ist', 'is'],
    KPFMultipleAspect: ['ist eines von', 'is one of'],
    ChancenRoleFilterAspect: ['ist', 'is'],
    PartnerActiveAspect: ['ist', 'is'],
    ChancenwerkUserAspect: ['ist', 'is'],
    ChancenRoleAspect: ['ist', 'is'],
    ChancenRoleMultiAspect: ['ist eines von', 'is one of'],
    BundeslandAspect: ['ist', 'is'],
    PartnerAspect: ['ist', 'is'],
    ZipCityAspect: ['ist', 'is'],
    Student: ['Schüler:in', 'Student'],
    Mitarbeiter: ['Mitarbeiter:in', 'Employee'],
    VerwaltungsMitarbeiter: ['Verwaltungsmitarbeiter:in', 'Administrative personal'],
    ExternerMitarbeiter: ['Mitarbeiter:in', 'Employee'],
    ExternalContactPerson: ['externe Kontaktperson', 'external person'],
  },

  tags: { fromOSAcquisition: ['OS-Interessent:in'], fromAbschluss: ['ABS-Teilnehmer:in'] },

  field: {
    ...butFieldTranslation,
    method: ['Kontaktart'],
    contactPersonType: ['Kontakt mit'],
    proWoche: ['Pro Woche'],
    dauer: ['Dauer'],
    US: ['Anzahl US'],
    grade: ['Note'],
    gradeExtraInfo: ['Weitere Angaben'],
    publicName: ['öffentlicher Name', 'Public name'],
    linkedUser: ['CHANCENraum Nutzer'],
    subdivisions: ['untergeordneter Kooperationspartner'],
    highPriority: ['Hohe Priorität', 'High Priority'],
    fromWhen: ['Ab wann', 'From when'],
    cameCount: ['Anzahl Teilnahmen', 'Participation count'],
    fillType: ['Füllungstyp', 'Fill type'],
    specialSkills: ['Besondere Fähigkeiten', 'Special skills'],
    telefonBewerber: ['Telefon Bewerber', 'Applicant phone'],
    bewerbungslink: ['Bewerbungslink', 'Application link'],
    schnuppertagDatum: ['Schnuppertag Datum', 'Trial day date'],
    datumVersandWillkommensmail: ['Datum Versand Willkommensmail', 'Welcome email sent date'],
    datumErsteTeilnahmeLernfoerderung: [
      'Datum erste Teilnahme Lernförderung',
      'First learning support participation date',
    ],
    datumTeilnahmeWorkshop1: ['Datum Teilnahme Workshop 1', 'Workshop 1 participation date'],
    datumTeilnahmeWorkshop2: ['Datum Teilnahme Workshop 2', 'Workshop 2 participation date'],
    datumFeedbackunterlagenErhalten: ['Datum Feedbackunterlagen erhalten', 'Feedback documents received date'],
    datumFeedbackgespraech: ['Datum Feedbackgesprách', 'Feedback meeting date'],
    editedBy: ['bearbeitet von', 'Edited by'],
    editedAt: ['bearbeitet am', 'Edited at'],
    datumEinfuehrungLKK: ['Datum Einführung LKK', 'LKK introduction date'],
    datumChancenSpirit: ['Datum CHANCENspirit', 'ChancenSpirit date'],

    ...defaultWikiTranslation.field,
    KPF: ['KPF'],
    levumiHasMerged: ['LEVUMI resultate wurden übertragen'],
    freigabeaktionen: ['Freigabeaktionen'],
    accessToken: ['Token'],
    weekdays: ['Wochentage'],
    studentCreationMailOverride: ['Lehrer Email für Anmeldungen'],
    acceptedCount: ['Anzahl Anmeldungen'],
    declinedCount: ['Anzahl abgesagter Teilnahmen'],
    sprachbedarf: ['hier Sprache angeben'],
    _id: ['Datenbank-ID'],
    tags: ['Art-Kategorie'],
    client: ['Kund:in'],
    orderNumber: ['Bestellnummer'],
    status: ['Status'],
    productCategory: ['Produkte'],
    kpf: ['KPF'],
    faecher: ['Fächer', 'Subject'],
    subject: ['Fach'], // flat translation for patch rendering (versioned entity
    approved: ['Fach bestätigt'], // flat translation for patch rendering (versioned entity)
    resultInfo: ['Letzter CHANCENkurve Test'],
    semanticRoles: ['Rolle'],
    workshopFilter: ['Veranstaltungstitel'],
    workshopDate: ['Veranstaltung/Workshop Teilnahme/Durchführung Datum'],
    workshopStatus: ['Veranstaltung Status'],
    workshopExists: ['Veranstaltung Teilnahme/Anmeldung existiert'],
    workshopIsNotTraining: ['Workshopdurchführung'],
    schuelertyp: ['Unter-/Oberstufe'],
    kooperationspartner: ['Kooperationspartner'],
    gespraechsfuehrungChancenWerk: ['Gesprächsführung'],
    weitereBeteiligtePersonen: ['weitere beteiligte Personen'],
    occasion: ['Art'],
    date: ['Kontakt am'],
    open: ['Offen'],
    margin: ['Margin'],
    padding: ['Padding'],
    display: ['Anzeigeart'],
    permission: ['Berechtigung'],
    username: ['Nutzer:innenname'],
    email: ['E-Mail (privat)'],
    roles: {
      _root: ['Rollen im Permissionsystem'],
      name: ['Name der Rolle'],
      contexts: ['Kontext der Rolle'],
      permissions: ['errechnete Berechtigungen'],
    },
    ios_sub: ['IOS-Pushnotification ID'],
    emailConfirmed: ['E-Mail bestätigt'],
    flags: { _root: ['Kampagenselektion'], getAll: ['Gesamtauswahl'] },
    vorname: ['Vorname'],
    nachname: ['Nachname'],
    adresse: { _root: ['Adresse'] },
    zip: ['PLZ'],
    city: ['Stadt'],
    strasse: ['Straße und Hausnummer'],
    careOf: ['Adresszusatz'],
    country: ['Land ungleich Deutschland'],
    address: { _root: ['Adresse'] },
    zipCity: { _root: ['PLZ & Stadt'] },
    schoolAddress: ['Schuladresse'],
    schoolName: ['Schule'],
    foundationName: ['Förderpartner:in'],
    validUntil: ['Verfügbar bis'],
    code: ['Token'],
    getAll: ['Gesamtauswahl'],
    deferred: ['zurückgestellt'],
    gradSubs: ['CHANCENabschluss Fächer'],
    postfach: ['Postfach'],
    postfachPlz: ['Postfach PLZ'],
    postfachOrt: ['Postfach Ort'],

    divisionURL: ['Kooperationspartnereinheit URL'],
    parentID: ['Übergeordnete Kooperationspartnereinheit ID'],
    parent: ['Übergeordnete Kooperationspartnereinheit'],
    getsInfoAnniversary: ['Soll Jubiläumsinfo erhalten'],
    getsChristmascard: ['Soll Weihnachtskarte erhalten'],
    getsYearlyReport: ['Soll Jahresbericht erhalten'],

    getsInfoAnniversaryRecord: { _root: ['Juiläumskartenversand'] },
    getsChristmascardRecord: { _root: ['Weihnachtskartenversand'] },
    getsYearlyReportRecord: { _root: ['Jahresberichtversand'] },
    comment: ['Kommentar'],
    user: ['Nutzer'],
    when: ['Wann'],
    evaluationID: ['Evaluation-ID'],
    lastPasswordChange: ['Letzte Passwortänderung'],
    geburtstag: ['Geburtstag'],
    geschlecht: ['Geschlecht'],
    salutationInConversation: ['Anrede im Gespräch'],
    salutationInLetter: ['Anrede im Brief'],
    title: ['Titel'],
    handynummer: ['Handynummer (privat)'],
    secondTelefone: ['zweite Telefonnummer (privat)'],
    contactSource: ['Kontaktquelle Sonstiges'],
    contactSourcePersonID: ['Kontaktquelle ID'],
    personalSignOnChrstimasCardFromID: ['Weihnachtkarte personalisiert durch ID'],
    guestAccount: ['Gast-Account'],
    blankoAccount: ['Blanko-Account'],
    alternativeContactPerson: ['Alternative Kontaktperson'],
    ...bankInformationTranslations,
    bankInformation: { _root: ['Bankinformationen'], ...bankInformationTranslations },
    businessAddress: { _root: ['Dienstadresse'], partnerID: ['Partner-ID'], partnerName: ['Partnername'] },
    customBusinessAddress: { _root: ['Dienstadresse*'] },
    businessAddressExtra: ['Dienstadresse-Adresszusatz'],
    _class: ['Art'],
    schoolInformation: { _root: ['Schulinformationen'], jahrgangsstufe: ['Jahrgangsstufe'] },
    lastAttendance: ['Letzte Anwesenheit'],
    attendanceCount: ['Anzahl Anwesenheiten'],
    attendanceStats: {
      _root: ['Anwesenheitensstatistik'],
      lastAttendance: ['Letzte Anwesenheit'],
      attendanceCount: ['Anzahl Anwesenheiten'],
    },
    lastChangeOnJahrgangsstufeByUser: ['letzte Änderung Jahrgangsstufe von'],
    isOnline: ['Aktuell online'],
    createdAt: ['angelegt am'],
    name: ['Name'],
    kuerzel: ['Kürzel'],
    lastChanged: ['Letzte Änderung'],
    contactSourcePerson: { _root: ['Kontaktperson'] },
    partnerName: ['Kooperationspartner'],
    bundesland: ['Bundesland'],
    startDate: ['Startdatum'],
    start: ['Wann'],
    pausedAt: ['Pausiert seit'],
    endAt: ['Enddatum'],
    probabilityOfDuplicate: ['Wahrscheinlichkeit einer Dopplung'],
    active: ['Aktiv'],
    kpfs: { _root: ['KPF'], product: productFieldTranslation, produkt: productFieldTranslation },
    kpfsMultiple: { _root: ['KPF'], product: productFieldTranslation, produkt: productFieldTranslation },
    chancenID: ['ID'],
    role: ['Rolle'],
    tätigkeiten: ['Tätigkeiten'],
    jahrgangsstufe: ['Jahrgangsstufe'],
    membership: ['Mitgliedschaft'],
    telefonNumber: ['Telefonnummer'],
    personalSignOnChrstimasCardFrom: ['Weihnachtskartenversand personalisiert durch'],
    socialIndicators: ['Sozialindikator'],
    acquisitionStartedDate: ['Akquise gestartet'],
    endDate: ['Enddatum'],
    zusammenArbeitStringForDetails: ['Mitgliedschaft'],
    endedReason: ['Beendigungsgrund'],
    sizeOfSchoolInNumberOfStudents: ['Anzahl der Schüler:innen'],
    numberOfTeachers: ['Anzahl der Lehrer:innen'],
    specialCasesAndMisc: ['Besonderheiten'],
    contactReason: ['Kontaktgrund'],
    acquisitionMultiplicatorPerson: { _root: ['Multiplikatorperson'] },
    info: ['Info'],
    acquisitionMultiplicatorPersonPosition: ['Multiplikatorperson Rolle'],
    acquisitioContactHistory: ['Kontaktverlauf'],
    acquisitionMeetingDate: ['Akquisegespräch-Datum'],
    acquisitionReasonForCancellation: ['Grund für Absage der Akquise'],
    acquisitionTerminationDate: ['Akquise-Absagedatum'],
    acquisitionHandOverEmail: ['Übergabe-E-Mail-Datum'],
    stateOfContactRequest: ['Status der Gesprächsanfrage'],
    stateOfContactRequestMoreDetail: ['Grund für Absage der Akquise-Details'],
    schoolSupport: ['Schulteambegleitung'],
    endedTroughPerson: { _root: ['Beendet durch'] },
    roleFromPersonEndedTrough: ['Beendet durch Person in Rolle'],
    personDidAcquisitionMeeting: ['Akquisegespräch-Person'],
    handoverEmailWrittenBy: { _root: ['Übergabe-E-Mail geschrieben von'] },
    cooperationContractSentOn: ['Rahmenvereinbarung gesendet am'],
    cooperationContractBackOn: ['Rahmenvereinbarung zurückerhalten am'],
    productStrings: ['Produkte'],
    standort: ['Standort'],
    schulform: ['Schulform'],
    hasBuTStatus: ['BuT-Status'],
    url: ['Website URL'],
    lastLearningMaterialOrderDate: ['Letzte Lernmaterial-Bestellung'],
    lastAdvertisingMaterialOrderDate: ['Letzte Werbematerial-Bestellung'],
    materialClosetOwner: ['Materialschrankschlüssel-Besitzer:in'],
    materialClosetOwnerIsCW: ['Materialschrank gehöhrt CHANCENwerk'],
    materialClosetPosition: ['Materialschrank-Position'],
    keyLernfoerderungRooms: ['Lernförderraum-Schlüssel'],
    personalAllowedToUsePrinter: ['Drucker/Kopierer benutzbar'],
    hideOnWebsite: ['Kooperationspartner ist auf der CHANCENwerk-Webseite versteckt'],
    zugConfiguration: ['Zug-Konfiguration'],
    interestedProducts: ['Produktinteressen'],
    wlanAccess: ['WLAN verfügbar'],
    wlanPassword: ['WLAN-Passwort'],
    noWlanReason: ['Grund für kein WLAN-Verfügbarkeit'],
    fundingYear: ['Förderjahr'],
    changePassword: ['Passwort ändern'],
    Mitgliedschaftszeitraum: ['Mitgliedschaftszeitraum'],
    inactive: ['Inaktiv in der Lernförderung'],
    beruf: ['Beruf'],
    staatsangehoerigkeit: ['Staatsangehörigkeit'],
    legalGuardian1: { _root: ['Erster Erziehungsberechtigte Person'] },
    legalGuardian2: { _root: ['Zweite Erziehungsberechtigte Person'] },
    festnetznummer: ['Festnetznummer'],
    lastChangeOnJahrgangsstufeByUserName: ['Letzte Änderung der Jahrgangsstufe von'],
    lastChangeOnJahrgangsstufe: ['Letzte Änderung der Jahrgangsstufe am'],
    abweichendeSchule: ['Abweichende Schule'],
    abweichendeSchuleResolved: ['Abweichende Schule'],
    zug: ['Zug'],
    klassenlehrer: ['Klassenlehrer:in'],
    legalGuardianContactMethods: ['Bevorzugte Kontaktmethode der Erziehungsberechtigten'],
    lernfoerderungDuerchfuehrungsTagChoosen: ['Gewählte Tage für Lernförderung'],
    joinInformation: {
      _root: ['Eintrittsinformationen'],
      eintrittsdatum: ['Eintrittsdatum'],
      registermethode: ['Anmeldemethode'],
      sendedPartTwoTillFive: ['Versand von Anmeldeunterlagen an Eltern'],
      campusRegisterDataSend: ['Schüler:in-Account für Campus aktiviert'],
    },
    calledBackAt: ['zurückgerufen am (OS-Akquise)'],
    consent: {
      _root: ['Zustimmung'],
      gotSignedInfopostBack: ['Verwaltung hat unterschriebene Anmeldeunterlagen zurückerhalten'],
      einverstaendnisBild: ['Einverständnis Bild'],
      einverstaendnisEntbindungVonVerschwiegenheit: ['Aufsichtspflicht'],
      confidential: ['Einverständnis Vertraulich'],
      learningDeficiencies: ['Einverständnis Lernschwächen'],
      einverstaendnisEvaluation: ['Einverständnis Evaluation'],
    },
    kuendigung: {
      _root: ['Kündigung'],
      austrittsdatum: ['Austrittsdatum'],
      confirmationEmailSend: ['Bestätigungsemail gesendet'],
      confirmationEmailSendAt: ['Bestätigungsemail gesendet am'],
      confirmationEmailProcessFinished: ['Bestätigungsemail-Prozess abgeschlossen'],
      kuendigungGrund: ['Kündigungsgrund'],
      kuendigungGrundSonst: ['sonstiger Kündigungsgrund'],
      kuendigungArt: ['Art der Kündigung'],
      kuendigungDurch: ['Kündigung durch'],
    },
    funding: {
      _root: ['Förderbedarf'],
      foerderbedarfLautEltern: ['Förderbedarf des Kindes'],
      teilleistungsschwaechen: ['Teilleistungsschwächen'],
      teilleistungsschwaechenSonst: ['sonstige Teilleistungsschwächen'],
      vermerkeSonst: ['sonstige Vermerke'],
    },
    useV2Courses: ['Neue Zuteilung nach Tagen aktivieren'],
    archiveV1After: ['Neue Zuteilung nach Datum'],
    mitgliedschaft: ['Mitgliedschaft'],
    bildungsKarteNummer: ['Bildungskartennummer'],
    zustellbesonderheiten: ['Zustellbesonderheiten'],
    daysAvailable: ['Verfügbare Tage'],
    preferedFirstSubject: ['Bevorzugtes Erstfach'],
    preferedSecondSubject: ['Bevorzugtes Zweitfach'],
    preferedThirdSubject: ['Bevorzugtes Drittfach'],
    preferedOtherSubject: ['Bevorzugtes anderes Fach'],
    firstSubjectGraduationCourseType: ['Erstfach Kursart'],
    secondSubjectGraduationCourseType: ['Zweitfach Kursart'],
    thirdSubjectGraduationCourseType: ['Drittfach Kursart'],
    graduationInformation: {
      _root: ['CHANCENAbschluss Informationen'],
      type: ['Abschlussart'],
      registered: ['Angemeldet zum CHANCENabschluss'],
      firstSubjectGraduationCourseType: ['Erstfach Kursart'],
      secondSubjectGraduationCourseType: ['Zweitfach Kursart'],
      thirdSubjectGraduationCourseType: ['Drittfach Kursart'],
      firstSubjectGraduation: ['Erstfach'],
      secondSubjectGraduation: ['Zweitfach'],
      thirdSubjectGraduation: ['Drittfach'],
      openSubjectGraduation: ['Freitext Fach'],
      graduationFirstTestTopic: ['Erstfach Prüfungsthema'],
      graduationSecondTestTopic: ['Zweitfach Prüfungsthema'],
      graduationThirdTestTopic: ['Drittfach Prüfungsthema'],
    },
    examPreparationInformation: { _root: ['Prüfungsvorbereitung'], courses: ['Wöchentliches Prüfungstraining'] },
    intensiveCoursesChoosen: ['Crashkurse (mehrtägig)'],
    intensiveCoursesSingleChoosen: ['Crashkurse (eintägig)'],
    telefon: ['Telefon'],
    businessEmail: ['E-Mail (dienstlich)'],
    businessTelefone: ['Handynummer (dienstlich)'],
    businessSecondTelefone: ['Zweite Telefonnummer (dienstlich)'],
    emailChancenwerk: ['E-Mail (Chancenwerk)'],
    festnetz: ['Festnetz'],
    handynummerChancenwerk: ['Handynummer Chancenwerk'],
    hochschule: ['Hochschule'],
    studiengang: ['Studiengang'],
    kontaktaufnahmeFestnetznummer: ['Kontaktaufnahme Festnetznummer'],
    spokenLanguage: ['gesprochene Sprache'],
    unterlagen: {
      _root: ['Unterlagen'],
      vertragVersendet: ['Vertrag versendet'],
      vertragErhalten: ['Vertrag erhalten'],
      zusatzvereinbarungVersendet: ['Zusatzvereinbarung versendet'],
      zusatzvereinbarungErhalten: ['Zusatzvereinbarung erhalten'],
      selbstverplichtungserklaerungErhalten: ['Selbstverpflichtungserklärung erhalten'],
      datenschutzerklaerungErhalten: ['Datenschutzerklärung erhalten'],
      fuehrungzeugnisGueltigAb: ['Datum Führungszeugnis'],
      fuehrungzeugnisEinsichtnahmeErfolgt: ['Einsichtnahme in Führungszeugnis ist erfolgt'],
      fuehrungzeugnisRelevanteEintraege: ['Liegen relevante Einträge in Führungszeugnis vor'],
      vereinbarungUrheberrechtErhalten: ['Vereinbarung Urheberrecht erhalten'],
      byodFormularErhalten: ['BYOD Formular erhalten'],
      ersthelferkursAbsolviertAm: ['Ersthelferkurs absolviert am'],
      aktuelleMasernimpfungNachgewiesen: ['aktuelle Masernimpfung nachgewiesen'],
      einwilligungserklaerungMasernimpfungNachweisErhalten: ['Einwilligungserklärung Masernimpfung Nachweis erhalten'],
      personalNummer: ['Personalnummer'],
      kreditorenNummer: ['Kreditorennummer'],
      kommunikationMitUL: ['Kommunikation mit UL'],
      sonstigeVermerke: ['sonstige Vermerke'],
    },
    kontoInformationen: {
      _root: ['Kontoinformationen'],
      kontoinhaber: ['Kontoinhaber'],
      iban: ['IBAN'],
      bic: ['BIC'],
      kreditinstitut: ['Kreditinstitut'],
    },
    onboarding: {
      _root: ['Onboarding'],
      einarbeitungAbsolviertAm: ['Einarbeitung absolviert am'],
      onboardingAkademieAbsolviertAm: ['Onboarding-Akademie absolviert am'],
      feedbackquizCompletedAt: ['Feedback-Quiz absolviert am'],
      feedbacktalkCompletedAt: ['Feedback-Gespräch absolviert am'],
      trainingFinishedAt: ['Training fertiggestellt am'],
      schoolSpecificTrainingFinishedAt: ['Schulspezifisches Einarbeitung'],
    },
    workshopsAndTrainingInformation: {
      _root: ['Workshops und Schulungsinformationen'],
      participatedOSWorkshopOneRoleModel: ['Teilgenommen an OS-Workshop One Role Model'],
      carriedOutOSWorkshopOneRoleModel: ['Durchgeführt OS-Workshop One Role Model'],
      participatedOSWorkshopTwoChallenges: ['Teilgenommen an OS-Workshop Two Challenges'],
      carriedOutOSWorkshopTwoChallenges: ['Durchgeführt OS-Workshop Two Challenges'],
      participatedSuSWorkshopLearningToLearn: ['Teilgenommen an SuS-Workshop Learning To Learn'],
      carriedOutSuSWorkshopLearningToLearn: ['Durchgeführt SuS-Workshop Learning To Learn'],
      participatedSuSWorkshopMentalStrength: ['Teilgenommen an SuS-Workshop Mental Strength'],
      carriedOutSuSWorkshopMentalStrength: ['Durchgeführt SuS-Workshop Mental Strength'],
      participatedSusWorkshopInnerStrenght: ['Teilgenommen an Sus WorkshopinnerStrenght'],
      carriedOutSusWorkshopInnerStrenght: ['Durchgeführt Sus WorkshopInnerStrenght'],
      participatedULTrainingOSCompanion: ['Teilgenommen an ÜL-Training OSCompanion'],
      participatedULWorkshopCompentenceOne: ['Teilgenommen an ÜL-Workshop Competence One'],
      participatedULWorkshopCompentenceTwo: ['Teilgenommen an ÜL-Workshop Competence Two'],
      participatedULWorkshopMotivation: ['Teilgenommen an ÜL-Workshop Motivation'],
      participatedULWorkshopToDos: ['Teilgenommen an ÜL-Workshop ToDos'],
      participatedULWorkshopStress: ['Teilgenommen an ÜL-Workshop Stress'],
      participatedULWorkshopCommunication: ['Teilgenommen an ÜL-Workshop Communication'],
      participatedULWorkshopStorytelling: ['Teilgenommen an ÜL-Workshop Storytelling'],
      participatedULWorkshopLanguage: ['Teilgenommen an ÜL-Workshop Language'],
      participatedULWorkshopDidacticReduction: ['Teilgenommen an ÜL-Workshop Didactic Reduction'],
      participatedULHeftCampusKurve: ['Teilgenommen an ÜL-Heft Campuskurve'],
    },
    workAvailabilities: { _root: ['Arbeitsverfügbarkeiten'], weekday: ['Wochentag'], from: ['von'], to: ['bis'] },
    day: ['Tag'],
    timesAvailable: ['Anzahl der Verfügbarkeit'],
    type: ['Art'],
    firstSubjectGraduation: ['Abschluss Erstfach'],
    secondSubjectGraduation: ['Abschluss Zweitfach'],
    thirdSubjectGraduation: ['Abschluss Drittfach'],
    openSubjectGraduation: ['Abschluss offenes Fach'],
    graduationFirstTestTopic: ['Erstes Prüfungsthema Abschluss'],
    graduationSecondTestTopic: ['Zweites Prüfungsthema Abschluss'],
    graduationThirdTestTopic: ['Drittes Prüfungsthema Abschluss'],
    startDatum: ['Startdatum'],
    endDatum: ['Enddatum'],
    school: ['Partner'],
    createdByPerson: ['angelegt von'],
    ansprechPersonExtern: { _root: ['externe Ansprechsperson'] },
    butAnsprechPersonExtern: { _root: ['externe Ansprechsperson BuT'] },
    personsStrategisch: { _root: ['Person Strategisch'] },
    personsOperativ: { _root: ['Person Operativ'] },
    personsVerwaltung: { _root: ['Person Verwaltung'] },
    personsBUTOperativ: { _root: ['Person BuT Operativ'] },
    schuKos: { _root: ['SchuKos'] },
    leKos: { _root: ['LeKos'] },
    produkt: productFieldTranslation,
    product: productFieldTranslation,
    acquisitionCount: ['Anzahl OS-Akquise'],
    butStatus: ['BuT Status'],
    kostenstellennummer: ['Kostenstellennummer'],
    kommentar: ['Kommentar'],
    wochentag: ['Wochentag'],
    startZeit: ['Startzeit'],
    endZeit: ['Endzeit'],
    locations: ['Räume'],
    tokenAccessForExternalsEnabled: ['Token-Anmeldung für externe Lehrkräfte aktiviert'],
    accessTokenForExternals: ['Token für externe Lehrkräfte'],
    accessTokenForStudents: ['Token für Schüler:innen'],
    tokenAccessEnabled: ['Token-Anmeldung für Schüler:innen aktiviert'],
    tokenAccessCount: ['Aktuelle Anzahl der Token-Anmeldungen für Schüler:innen'],
    tokenAccessCountMax: ['Maximale Anzahl der Token-Anmeldungen für Schüler:innen'],
    osCoachMail: ['E-Mail OS-Coach'],
    schukoTel: ['SchuKo Telefonnummer'],
    osCoachTel: ['OS-Coach Telefonnummer'],
    standardMembershipFee: ['Standard Mitgliedschaftsbeitrag in €'],
    employeeOnKPF: ['Mitarbeiter auf KPF'],
    stateOfPartner: ['Bundesland'],
    state: ['Bundesland'],
    zipCityOfPartner: ['PLZ & Stadt'],
    category: ['Kategorie'],
    year: ['Schuljahr'],
    lastChangeDate: ['Letztes Änderungsdatum'],
    note: ['Notiz'],
    summary: ['Zusammenfassung'],
    customBusinessBundesland: ['Dienstadresse-Bundesland'],
    regard: ['Betreff'],
    securityLevel: ['Sicherheitsstufe'],
    creatorID: ['Ersteller-ID'],
    creator: ['Ersteller'],
    lastEditorID: ['Letzter Bearbeiter-ID'],
    lastEditor: ['Letzter Bearbeiter'],
    isProtocolNote: ['Ist Protokollnotiz'],
    protocolLink: ['Protokolllink'],
    kooperationspartnerID: ['Kooperationspartner-ID'],
    Kooperationspartner: ['Kooperationspartner'],
    gespraechsfuehrungChancenWerkIDs: ['Gesprächsführung Chancen WerkIDs'],
    Gesprächsführung: ['Gesprächsführung'],
    hospitationChancenWerkIDs: ['Hospitierende Chancen WerkIDs'],
    hospitationChancenWerk: ['Hospitierende'],
    weitereBeteiligtePersonenIDs: ['Weitere beteiligte PersonenIDs'],
    availableToReadForUserIDs: ['Verfügbar zum Lesen für Benutzer-IDs'],
    availableToReadForUsers: ['Verfügbar zum Lesen für Benutzer'],
    createdBy: ['angelegt von'],
    lastActivity: ['Letzte Aktivität am'],
    produktClass: ['Produkt'],
    socialIndicatorSchema: ['Sozialindikator (jüngster Stand)'],
    buts: { _root: ['BuT'], ...butFieldTranslation },
    butActive: { _root: ['BuT aktives Schuljahr'], ...butFieldTranslation },
    partnerActiveState: ['Aktiv'],
    partnerConnectedPerson: ['Verknüpfte Person'],
    partnerFunding: ['Förderpartner:in'],
    durchfuehrungsTage: ['Durchführungstage'],
    createdPerson: ['Angelegt von'],
    betKooperationspartner: ['Beteiligter Kooperationspartner'],
    contactType: ['Kontaktart'],
    contactProductName: ['Produkt'],
    contactDate: ['Kontaktdatum'],
    requiresTraining: 'Benötigt Schulung',
    description: 'Beschreibung',
    showAsOnboarding: 'Als Einarbeitung anzeigen',
    partnerRelations: 'Kooperationspartner beteiligt',
    customProduktLeKoDefault: 'Gesamt-Leko-Bedarf Startwert',
    customProduktLeKoCurrent: 'Gesamt-SchuKo-Bedarf aktueller Wert',

    bearbeiter: 'Bearbeiter:in',
    auftraggeber: 'Auftraggeber:in',
    isManuallyCreated: 'Ist manuelle Bestellung?',
    empfaenger: 'Empfänger:in',
  },

  'data-view': {
    ...dataViewTranslations['data-view'],
    search: ['Suche...'],
    addFilter: ['Filter-Feld hinzufügen'],
    save: ['Ansicht speichern'],
    incomplete: ['Unvollständig'],
  },
  ...translations,

  kuerzelPartner: ['Bitte geben Sie ein Kürzel für die Schule an.'],

  noValidLink: ['Kein gültiger Link.', 'No valid link.'],
  securityLevel0: ['Öffentlich', 'public'],
  securityLevel1: ['Nur für mich', 'Only me'],
  securityLevel2: ['Nur ausgewählte Personen', 'Only choosen Persons'],

  invalid_email: 'Bitte geben Sie eine E-Mail an.',
  validation_non_optional: ['Dieses Feld muss ausgefüllt werden.'],

  digital: ['Digital'],
  analog: ['Analog'],
};
